import React, { useState } from 'react'

import * as styles from './ccnewsletter.module.scss'
import { SvgCheck } from '../../components/ui/svg-icons/SvgCheck'
import SEOControl from '../../components/seoControl/seoControl'

const TITLE = 'This Week In Crypto | TWIC Newsletter by Bamboo'
const DESCRIPTION =
  'Get the most important crypto news each week, curated by the Bamboo team. Free newsletter.'

function CCNewsletterPage() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState('idle') // idle | loading | success | error

  const handleSubmit = async e => {
    e.preventDefault()
    if (!email) return
    setStatus('loading')

    try {
      const response = await fetch('/.netlify/functions/subscribe-newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })

      if (!response.ok) {
        throw new Error('Subscription failed')
      }

      setStatus('success')
    } catch (err) {
      setStatus('error')
    }
  }

  return (
    <>
      <SEOControl title={TITLE} description={DESCRIPTION} />

      {/* Section 1: Hero */}
      <section className={styles.hero} style={{width: '100%', alignSelf: 'stretch'}}>
        <div className={styles.heroInner}>
          <div className={styles.heroText}>
            <h1 className={styles.headline}>This Week In Crypto (TWIC)</h1>
            <p className={styles.hook}>
              📍 If you only catch up on crypto once this week, start here.
            </p>
            <ul className={styles.bulletList}>
              <li className={styles.bulletItem}>
                <span className={styles.checkIcon}>
                  <SvgCheck width="18" height="14" fill="#0047BB" />
                </span>
                <span>
                  Every week, Bamboo will bring you a digestible roundup of
                  crypto news and insights. Think of this as your weekly crypto
                  compass.
                </span>
              </li>
              <li className={styles.bulletItem}>
                <span className={styles.checkIcon}>
                  <SvgCheck width="18" height="14" fill="#0047BB" />
                </span>
                <span>
                  We highlight what matters, make sense of the noise, and give
                  you a quick view of the market — ideal whether you&apos;re a
                  crypto pro or just curious to learn.
                </span>
              </li>
            </ul>
          </div>
          <div className={styles.heroImage}>
            <img
              src="/assets/twic-newsletter-illustration.png"
              alt="This Week In Crypto"
              className={styles.illustration}
            />
          </div>
        </div>
      </section>

      {/* Section 2: Newsletter signup */}
      <section className={styles.signup} style={{width: '100%', alignSelf: 'stretch'}}>
        <div className={styles.signupInner}>
          <h2 className={styles.signupHeadline}>
            The latest crypto news delivered straight to your inbox
          </h2>
          <p className={styles.signupSubtitle}>Subscribe to our newsletter</p>

          {status === 'success' ? (
            <p className={styles.successMessage}>
              You&apos;re in! 🎉 Check your inbox soon.
            </p>
          ) : (
            <form className={styles.signupForm} onSubmit={handleSubmit}>
              <input
                className={styles.emailInput}
                type="email"
                placeholder="Email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <button
                className={styles.signupButton}
                type="submit"
                disabled={status === 'loading'}
              >
                {status === 'loading' ? 'Signing up…' : 'Sign me up'}
              </button>
            </form>
          )}

          {status === 'error' && (
            <p className={styles.errorMessage}>
              Something went wrong. Please try again.
            </p>
          )}
        </div>
      </section>

      {/* Section 3: Tagline strip */}
      <section className={styles.tagline} style={{width: '100%', alignSelf: 'stretch'}}>
        <p className={styles.taglineText}>
          Australia&apos;s Favorite Crypto Newsletter
        </p>
      </section>
    </>
  )
}

export default CCNewsletterPage
